module.exports = __webpack_public_path__ + "img/ZA.4ff8d3c4.png";